/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductReviewDetailed {
  ageRange?: string;
  beautyStyle?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  defaultProductVariantId?: number;
  descriptionArticleId?: string;
  email?: string;
  firstName?: string;
  hairColor?: string;
  hairType?: string;
  lastName?: string;
  nickname?: string;
  personId?: number;
  productId?: number;
  productName?: string;
  productReviewStatus?: string;
  productSummary?: string;
  productVariantId?: number;
  productVariantName?: string;
  rating?: number;
  replyId?: number;
  review?: string;
  reviewStatus?: number;
  reviewTitle?: string;
  rewardBalance?: number;
  skinTone?: string;
  skinType?: string;
  variantImageUrl?: string;
}
